import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() => ({
  historicChat: {
    width: '100%',
    maxHeight: 270,
    overflow: 'auto',
    background: '#f9f9f9',
    padding: 20,
    borderRadius: 5,
  },
  historicMessage: {
    width: 'auto',
    maxWidth: '300px',
    borderRadius: 4,
    marginBottom: 12,
    clear: 'both',
    fontSize: 14,
    lineHeight: '16px',
    fontWeight: 400,
    color: '#fff',

    '&.--producer': {
      float: 'right',
    },
    '&:last-child': {
      marginBottom: 0,
    },
  },
  historicName: {
    color: '#999',
    display: 'block',
    width: '100%',
    fontSize: 13,
  },
  historicContent: {
    width: 'auto',
    maxWidth: '100%',
    padding: '8px 16px',
    background: '#94C2ED',
    display: 'inline-block',
    borderRadius: 5,
    fontWeight: 400,
    position: 'relative',

    '&.--producer': {
      background: '#86BB71',
      float: 'right',
      marginBottom: 4,
    },
  },
  historicDate: {
    color: '#92959E',
    width: '100%',
    fontSize: 12,
    marginTop: 4,
    clear: 'both',

    '&.--producer': {
      marginTop: 0,
      textAlign: 'right',
    },
  },
  historicAnswer: {
    textAlign: 'right',
  },
}));
